import React from 'react';
import { useTranslation } from 'react-i18next';

// Kompakter DE/EN-Umschalter, wird neben dem Theme-Toggle in beiden Headern verwendet.
function LanguageSwitcher({ className }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'de').startsWith('en') ? 'en' : 'de';

  const toggle = () => {
    const next = current === 'de' ? 'en' : 'de';
    i18n.changeLanguage(next);
  };

  return (
    <button
      type="button"
      className={className}
      onClick={toggle}
      title={current === 'de' ? 'Switch to English' : 'Auf Deutsch wechseln'}
      aria-label="Sprache wechseln"
    >
      {current === 'de' ? '🇩🇪 DE' : '🇬🇧 EN'}
    </button>
  );
}

export default LanguageSwitcher;
